import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import Checkbox from "../../Components/checkbox/Checkbox";
import ApiDropdown from "../../Components/DropDown/Apidropdown";
import FileUploader from "../../Components/FileUpload/FileUpload";
import Input from "../../Components/input/input";
import TaskGridLookup from "../../Components/Lookup/Lookup"; // Adjust the path based on your project structure
import config from "../../config";
import "../../Style/IncidentAdd.css";
import { ChangeData } from "../../utils/Change/changeTypes";
import { TaskData } from "../../utils/Task/taskTypes";
import { useFetchFullName } from "../Incidents/Hooks/useFetchFullName";
import { Rma, initialRma } from "./Rma";
import { RmaData } from "../../utils/Rma/rmaTypes";
import { KnowledgeBaseData } from "../../utils/KnowledgeBase/KnowledgeBaseTypes";
import { IncidentData } from "../../utils/Incident/incidentTypes";
import { ProblemData } from "../../utils/Problem/problemTypes";
import TextArea from "../../Components/TextArea/TextArea";
import { authFetch } from "../../utils/Security/authFetch";
import ses from "../../Assets/ses.jpg";
import Button from "../../Components/button/button";
import { getSignatureLines } from "../../utils/emailSignature";

const RmaAdd: React.FC = () => {
  const username = localStorage.getItem("username");
  const isAdmin = localStorage.getItem("isAdmin") === "true";
  const isUser = localStorage.getItem("isUser") === "true";
  const [rma, setRma] = useState<Rma>(initialRma);
  const [showUserDialog, setShowUserDialog] = useState(false);
  const [customer, setCustomer] = useState<
      string | number | (string | number)[] | null
  >(null);
  const [emails, setEmails] = useState<[]>();
  const organization = localStorage.getItem("organization") || undefined;
  const isallsite = localStorage.getItem("isAllSite");
  const isallnetwork = localStorage.getItem("isAllNetwork");
  const isalllink = localStorage.getItem("isAllLink");
  const navigate = useNavigate();
  const [isTaskLookupOpen, setIsTaskLookupOpen] = useState(false);
  const isForNilesat = localStorage.getItem("isForNilesat") === "true";

  const [selectedTask, setSelectedTask] = useState<
      (
          | TaskData
          | ChangeData
          | RmaData
          | KnowledgeBaseData
          | ProblemData
          | IncidentData
          )[]
  >([]);
  const [network, setNetwork] = useState<
      string | number | (string | number)[] | null
  >(null);
  const [site, setSite] = useState<
      string | number | (string | number)[] | null
  >(null);

  const handleOpenTaskLookup = () => setIsTaskLookupOpen(true);
  const handleCloseTaskLookup = () => setIsTaskLookupOpen(false);

  const handleTaskSelect = (
      tasks: (
          | TaskData
          | ChangeData
          | RmaData
          | KnowledgeBaseData
          | ProblemData
          | IncidentData
          )[]
  ) => {
    const ticketIds = tasks.map((t) => t.ticketId); // collect all selected ticketIds
    handleChange("relatedobject", ticketIds); // now this should be an array
    setSelectedTask(tasks); // you might rename this to selectedTasks now
  };
  useEffect(() => {
    const storedUsername = localStorage.getItem("username");
    const storedPosition = localStorage.getItem("position") ?? "";
    if (storedUsername) {
      setRma((prev) => ({
        ...prev,
        createdby: storedUsername,
        responsiblePerson: storedUsername,
        responsibleTeam: storedPosition,
      }));
    }
  }, []);
  useEffect(() => {
    const { urgency, impact } = rma;
    if (!urgency || !impact) return;

    const key = `${urgency}-${impact}`;
    let priority = "";
    //console.log("${urgency}-${impact}", urgency, impact);
    if (key === "Critical-Critical" || key === "High-Critical")
      priority = "Critical";
    else if (
        key === "Critical-High" ||
        key === "High-High" ||
        key === "Medium-Critical"
    )
      priority = "High";
    else if (
        key === "Critical-Medium" ||
        key === "High-Medium" ||
        key === "Medium-High" ||
        key === "Medium-Medium"
    )
      priority = "Medium";
    else if (
        key === "Low-Low" ||
        key === "Low-Medium" ||
        key === "Low-High" ||
        key === "Low-Medium"
    )
      priority = "Low";

    setRma((prev) => ({
      ...prev,
      priority,
    }));
  }, [rma.urgency, rma.impact]);
  useFetchFullName((fullName: string) => {
    setRma((prev) => ({ ...prev, user: fullName }));
  });

  const handleChange = (field: keyof Rma, value: any) => {
    setRma((prev) => {
      const updated = { ...prev, [field]: value };

      // Apply "All" logic
      updated.affectedSite =
          isallsite === "true" ? ["All Sites"] : updated.affectedSite;
      updated.affectedLink =
          isalllink === "true" ? ["All Links"] : updated.affectedLink;
      updated.affectedNetwork =
          isallnetwork === "true" ? ["All Networks"] : updated.affectedNetwork;

      return updated;
    });
  };

  const validateForm = (): boolean => {
    if (!rma) {
      alert("Rma data is not available.");
      return false;
    }

    const requiredFields: (keyof Rma)[] = [];

    for (const field of requiredFields) {
      const value = rma[field];
      if (
          value === undefined ||
          value === null ||
          value.toString().trim() === ""
      ) {
        alert(`Please fill the required field`);
        return false;
      }
    }

    return true;
  };
  function getUtcDateTime(): string {
    const now = new Date();
    return (
        now.getUTCFullYear() +
        "-" +
        String(now.getUTCMonth() + 1).padStart(2, "0") +
        "-" +
        String(now.getUTCDate()).padStart(2, "0") +
        " " +
        String(now.getUTCHours()).padStart(2, "0") +
        ":" +
        String(now.getUTCMinutes()).padStart(2, "0") +
        ":" +
        String(now.getUTCSeconds()).padStart(2, "0")
    );
  }
  type ValType = string | number | (string | number)[] | null | undefined;

  const fetchCustomerData = async (val: ValType) => {
    try {
      let orgValue: string | number | (string | number)[];

      if (val === null || val === undefined) {
        orgValue = organization ?? "";
      } else {
        orgValue = val;
      }

      let orgQueryParam = "";

      if (Array.isArray(orgValue)) {
        orgQueryParam = orgValue
            .map((item) => encodeURIComponent(String(item)))
            .join(",");
      } else {
        orgQueryParam = encodeURIComponent(String(orgValue));
      }

      const responseIds = await authFetch(
          `${config.apiBaseUrl}/api/users/id-by-organization?organization=${orgQueryParam}`
      );
      if (!responseIds.ok)
        throw new Error(`HTTP error! status: ${responseIds.status}`);

      const userIds = await responseIds.json();

      //console.log("Fetched user IDs:", userIds);

      const userIdsParam = Array.isArray(userIds) ? userIds.join(",") : userIds;

      const responseEmails = await authFetch(
          `${config.apiBaseUrl}/api/users/email-by-id?id=${userIdsParam}`
      );
      if (!responseEmails.ok)
        throw new Error(`HTTP error! status: ${responseEmails.status}`);

      const emails = await responseEmails.json();

      setEmails(emails);

      handleChange("foruserid", userIds);

      if (Array.isArray(val) && val.length === 0) {
        handleChange("affectedCustomer", [organization]);
      } else {
        handleChange("affectedCustomer", [val]);
      }
    } catch (error) {
      console.error("Failed to fetch customer or emails:", error);
    }
  };
  useEffect(() => {
    if (organization && !isForNilesat) {
      fetchCustomerData(organization);
    }
  }, [organization]);


  useEffect(() => {
    if (isForNilesat) {
      const fetchNilesatData = async () => {
        try {
          const responseIds = await authFetch(
              `${config.apiBaseUrl}/api/users/id-by-organization?organization=Nilesat`
          );
          if (!responseIds.ok) throw new Error("Failed");

          const userIds = await responseIds.json();
          const userIdsParam = Array.isArray(userIds)
              ? userIds.join(",")
              : userIds;

          const responseEmails = await authFetch(
              `${config.apiBaseUrl}/api/users/email-by-id?id=${userIdsParam}`
          );
          const emails = await responseEmails.json();
          setEmails(emails);

          handleChange("foruserid", userIds);
          handleChange("affectedCustomer", ["Nilesat"]);
          setCustomer("Nilesat");
        } catch (error) {
          console.error("Failed to fetch Nilesat customer or emails:", error);
        }
      };

      fetchNilesatData();
    }
  }, [isForNilesat]);

  const handleSubmit = async () => {
    if (!validateForm()) return;

    try {
      const response = await authFetch(`${config.apiBaseUrl}/api/rmas`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(rma),
      });

      const savedIncident = await response.json();
      rma.ticketId = savedIncident.ticketId;
      rma.ticketCreationDatetime = getUtcDateTime();

      const isallsite = localStorage.getItem("isAllSite");
      const isallnetwork = localStorage.getItem("isAllNetwork");
      const isalllink = localStorage.getItem("isAllLink");
      const isAdmin = localStorage.getItem("isAdmin") === "true";

      const bcom = [
        "p.horkos@bcomsat.com",
        "m.matta@bcomsat.com",
        "a.hanna@bcomsat.com",
        "g.kattan@bcomsat.com",
        "c.nakhle@bcomsat.com",
      ];

      const recipients = emails ?? [];
      const jackson = ["jacksondoumith006@gmail.com", "g.kattan@bcomsat.com"];

      const siteInfo =
          isallsite === "true" ? "All Sites" : rma.affectedSite ?? "";
      const linkInfo =
          isalllink === "true" ? "All Links" : rma.affectedLink ?? "";
      const networkInfo =
          isallnetwork === "true" ? "All Networks" : rma.affectedNetwork ?? "";

      // Email body generator
      const buildEmailBody = () => `
      Hello,<br><br>
      A ticket with ID ${
          rma.ticketId
      } has been opened with the following comment: <br><br>
      Ticket ID: ${rma.ticketId}<br>
      Status: New <br>
      Track Stage: ${rma.trackstage}<br>
      Ticket creation date/time:  ${rma.ticketCreationDatetime?.replace(
          "T",
          " "
      )}<br>
      Ticket closure date/time:  ${
          rma.ticketClosureDatetime
              ? rma.ticketClosureDatetime.replace("T", " ")
              : ""
      }<br>
      Point of contact:  ${rma.pointofcontact ?? ""}<br>
      brand: ${rma.brand ?? ""} <br>
      Model: ${rma.model ?? ""}<br>
      Part number: ${rma.partnumber ?? ""} <br>
      Serial number: ${rma.serialnumber ?? ""} <br>
      Password (optional):  ${rma.password ?? ""}<br>
      Fault Description/Analysis/Troubleshooting: ${
          rma.faultdescription ?? ""
      }<br>
      Customer: ${rma.affectedCustomer ?? ""}<br>
      Network:  ${rma.affectedNetwork ?? ""}<br>
      Site: ${rma.affectedSite ?? ""} <br>
      Active warranty (yes or no): ${rma.activewarranty ?? ""}<br>
      Is customer importer of the record? (yes or no): ${rma.ior ?? ""}<br>
      Company name: ${rma.companyname ?? ""} <br>
      Name: ${rma.name ?? ""} <br>
      Email: ${rma.email ?? ""} <br>
      Phone number:  ${rma.phonenumber ?? ""}<br>
      Address line1: ${rma.address1 ?? ""} <br>
      Address line2: ${rma.address2 ?? ""} <br>
      City:  ${rma.city ?? ""}<br>
      Region:  ${rma.region ?? ""}<br>
      Country: ${rma.country ?? ""} <br>
      Zip:  ${rma.zip ?? ""}<br>
      <br>
      Regards, <br>
      <a href="https://bdm.bcomsat.com" target="_blank" style="color: #ffa500; font-weight: bold; text-decoration: none;">
        👉 View RMA Details
      </a>
      </p>
      <table cellpadding="0" cellspacing="0" border="0" style="margin-top: 20px;">
      <tr>
        <td style="vertical-align: top; padding-right: 12px;">

         <img src="cid:seslogo" alt="SES Logo" style="height:50px;width:auto;" />
      

        </td>

        <td>
          <div style="
            padding: 12px;
            border-left: 4px solid #2a1364;
            background-color: #f9f9f9;
            color: #2a1364;
            font-size: 13px;
          ">
            <strong>Managed Services Operations</strong><br>
            ${getSignatureLines(rma.affectedCustomer, "#2a1364")}
          </div>
        </td>
      </tr>
    </table>
    `;

      try {
        if (isAdmin) {
          await authFetch(`${config.apiBaseUrl}/api/email/send`, {
            method: "POST",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify({
              to: bcom,
              subject: `A RMA with ID ${rma.ticketId} has been opened`,
              body: buildEmailBody(),
            }),
          });
        } else {
          if (recipients.length > 0) {
            await authFetch(`${config.apiBaseUrl}/api/email/send`, {
              method: "POST",
              headers: { "Content-Type": "application/json" },
              body: JSON.stringify({
                to: recipients,
                subject: `A RMA with ID ${rma.ticketId} has been opened`,
                body: buildEmailBody(),
              }),
            });
          }
          await authFetch(`${config.apiBaseUrl}/api/email/send`, {
            method: "POST",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify({
              to: bcom,
              subject: `A RMA with ID ${rma.ticketId} has been opened`,
              body: buildEmailBody(),
            }),
          });
        }

        localStorage.setItem("email", rma.email);
      } catch (emailErr) {
        console.error("Failed to send email notification:", emailErr);
      }

      if (!response.ok) throw new Error("Failed to submit rma");

      alert("Rma submitted successfully!");
      setRma({ ...initialRma, ticketId: rma.ticketId });
      navigate("/rma-request");
    } catch (error) {
      alert(`Submission error: ${(error as Error).message}`);
      console.error(`Submission error: ${(error as Error).message}`);
    }
  };

  useEffect(() => {
    if (!rma.ticketId) {
      const randomId = `RMA${Math.floor(10000 + Math.random() * 90000)}`;
      setRma((prev) => ({ ...prev, ticketId: randomId }));
    }
  }, []);

  return (
      <div className="incident-form">
        <section className="form-section">
          <h3>RMA Information</h3>
          <div className="grid">
            <Input
                type="text"
                label="Created By"
                value={rma.createdby ?? ""}
                onChange={(val) => handleChange("createdby", val)}
                readOnly
            />
            <ApiDropdown
                api="users"
                labelKey="username"
                valueKey="id"
                label="User"
                onChange={async (val) => {
                  handleChange("userid", val);
                  try {
                    const res = await authFetch(
                        `${config.apiBaseUrl}/api/users/${val}`
                    );
                    if (!res.ok) throw new Error("User not found");
                    const user = await res.json();
                  } catch (err) {
                    console.error("Error fetching user:", err);
                  }
                }}
            />

            {isAdmin && (
                <Input
                    type="text"
                    label="Vendor RMA cross reference number"
                    value={rma.vendorrmacross}
                    onChange={(val) => handleChange("vendorrmacross", val)}
                />
            )}
            <ApiDropdown
                api="track"
                labelKey="name"
                valueKey="name"
                value={rma.trackstage}
                label="Track Stage"
                onChange={(val) => handleChange("trackstage", val)}
            />

            <Input
                readOnly
                type="text"
                label="Ticket ID"
                value={rma.ticketId || ""}
                onChange={() => {}}
            />
            {/* <Input
            type="text"
            label="Customer"
            required={true}
            value={rma.customer}
            onChange={(val) => handleChange("customer", val)}
          /> */}
            {/* <Input
            type="text"
            label="Point Of Contact"
            value={rma.pointofcontact}
            onChange={(val) => handleChange("pointofcontact", val)}
          /> */}
          </div>
        </section>

        <section className="form-section">
          <h3>Customer Contact Information</h3>
          <div className="grid">
            {!isAdmin && !isForNilesat &&(
                <ApiDropdown
                    api="affected-customers"
                    required={true}
                    labelKey="customername"
                    disabled
                    value={organization}
                    valueKey="customername"
                    label="Customer"
                    isMulti
                    onOpen={async () => {
                      try {
                        const responseIds = await authFetch(
                            `${config.apiBaseUrl}/api/users/id-by-organization?organization=${organization}`
                        );
                        if (!responseIds.ok)
                          throw new Error(
                              `HTTP error! status: ${responseIds.status}`
                          );
                        const userIds = await responseIds.json();

                        const userIdsParam = Array.isArray(userIds)
                            ? userIds.join(",")
                            : userIds;
                        const responseEmails = await authFetch(
                            `${config.apiBaseUrl}/api/users/email-by-id?id=${userIdsParam}`
                        );
                        if (!responseEmails.ok)
                          throw new Error(
                              `HTTP error! status: ${responseEmails.status}`
                          );
                        const emails = await responseEmails.json();
                        setEmails(emails);

                        handleChange("foruserid", userIds);

                        handleChange("affectedCustomer", [organization]);
                      } catch (error) {
                        console.error("Failed to fetch customer or emails:", error);
                      }
                    }}
                />
            )}
            {isAdmin && !isForNilesat &&(
                <ApiDropdown
                    api="affected-customers"
                    labelKey="customername"
                    required={true}
                    valueKey="customername"
                    label="Customer"
                    isMulti
                    onChange={async (val) => {
                      setCustomer(val);
                      //console.log("eeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeee", val);
                      handleChange("affectedCustomer", val);
                      try {
                        const responseIds = await authFetch(
                            `${config.apiBaseUrl}/api/users/id-by-organization?organization=${val}`
                        );
                        if (!responseIds.ok)
                          throw new Error(
                              `HTTP error! status: ${responseIds.status}`
                          );
                        const userIds = await responseIds.json();
                        //console.log("Fetched user IDs:", userIds);

                        const userIdsParam = Array.isArray(userIds)
                            ? userIds.join(",")
                            : userIds;
                        const responseEmails = await authFetch(
                            `${config.apiBaseUrl}/api/users/email-by-id?id=${userIdsParam}`
                        );
                        if (!responseEmails.ok)
                          throw new Error(
                              `HTTP error! status: ${responseEmails.status}`
                          );
                        const emails = await responseEmails.json();
                        setEmails(emails);
                        console.log("Fetched emails:", emails);

                        handleChange("foruserid", userIds);
                      } catch (error) {
                        console.error("Failed to fetch customer or emails:", error);
                      }
                    }}
                />
            )}
            {isAdmin && isForNilesat && (
                <ApiDropdown
                    api="affected-customers"
                    labelKey="customername"
                    required={true}
                    valueKey="customername"
                    label="Customer"
                    value={"Nilesat"}
                    disabled
                />
            )}


            {!isAdmin && organization && (
                <ApiDropdown
                    api={`everything/networks?customer=${organization}`}
                    labelKey="label"
                    valueKey="value"
                    label=" Networks"
                    required={true}
                    isMulti
                    onChange={(val) => {
                      setNetwork(val);
                      handleChange("affectedNetwork", val);
                    }}
                />
            )}

            {!isAdmin && !isForNilesat && organization && (
                <>
                  {network && (
                      <ApiDropdown
                          api={`everything/sites?customer=${organization}&network=${network}`}
                          labelKey="label"
                          valueKey="value"
                          label=" Site"
                          isMulti
                          onChange={(val) => {
                            setSite(val);
                            handleChange("affectedSite", val);
                          }}
                      />
                  )}

                  {/* {site && (
                <ApiDropdown
                  api={`everything/links?customer=${organization}&network=${network}&site=${site}`}
                  labelKey="label"
                  valueKey="value"
                  label=" Link"
                  isMulti
                  onChange={(val) => handleChange("affectedLink", val)}
                />
              )} */}
                </>
            )}

            {isAdmin && !isForNilesat &&(
                <>
                  {customer && (
                      <ApiDropdown
                          api={`everything/networks?customer=${customer}`}
                          labelKey="label"
                          valueKey="value"
                          label="Networks"
                          required
                          isMulti
                          onChange={(val) => {
                            setNetwork(val);
                            handleChange("affectedNetwork", val);
                          }}
                      />
                  )}

                  {network && (
                      <ApiDropdown
                          api={`everything/sites?customer=${customer}&network=${network}`}
                          labelKey="label"
                          valueKey="value"
                          label="Site"
                          isMulti
                          onChange={(val) => {
                            setSite(val);
                            handleChange("affectedSite", val);
                          }}
                      />
                  )}

                  {/* {site && (
                <ApiDropdown
                  api={`everything/links?customer=${customer}&network=${network}&site=${site}`}
                  labelKey="label"
                  valueKey="value"
                  label="Link"
                  isMulti
                  onChange={(val) => handleChange("affectedLink", val)}
                />
              )} */}
                </>
            )}

            {isAdmin && isForNilesat && (
                <ApiDropdown
                    api={`everything/networks?customer=Nilesat`}
                    labelKey="label"
                    valueKey="value"
                    label=" Networks"
                    required={true}
                    isMulti
                    onChange={(val) => {
                      setNetwork(val);
                      handleChange("affectedNetwork", val);
                    }}
                />
            )}
            <Input
                type="text"
                label="Point Of Contact"
                value={rma.pointofcontact}
                onChange={(val) => handleChange("pointofcontact", val)}
            />
            <Input
                type="text"
                label="Customer Name"
                value={rma.customername || ""}
                onChange={(val) => handleChange("customername", val)}
            />
          </div>
        </section>

        <section className="form-section">
          <h3>Device Information</h3>
          <div className="grid">
            <Input
                type="text"
                label="Brand"
                value={rma.brand}
                onChange={(val) => handleChange("brand", val)}
            />
            <Input
                type="text"
                label="Model"
                value={rma.model}
                onChange={(val) => handleChange("model", val)}
            />

            <Input
                type="text"
                label="Part Number"
                value={rma.partnumber}
                required
                onChange={(val) => handleChange("partnumber", val)}
            />
            <Input
                type="text"
                label="Serial Number"
                required
                value={rma.serialnumber}
                onChange={(val) => handleChange("serialnumber", val)}
            />
            <Input
                type="text"
                label="Password (optional)"
                value={rma.password}
                onChange={(val) => handleChange("password", val)}
            />
            <ApiDropdown
                api="yesno"
                labelKey="name"
                valueKey="name"
                label="Active Warranty Yes/No"
                value={rma.activewarranty}
                onChange={(val) => handleChange("activewarranty", val)}
            />
            {/* BREAK ROW: full-width */}
            <div className="grid-full-width">
              <TextArea
                  style={{ width: "100%" }}
                  label="Fault Description /Analysis /Troubleshooting"
                  value={rma.faultdescription}
                  onChange={(val) => handleChange("faultdescription", val)}
              />
            </div>
          </div>
        </section>

        <section className="form-section">
          <h3>Information</h3>
          <div className="grid">
            <>
              <ApiDropdown
                  api="yesno"
                  labelKey="name"
                  valueKey="name"
                  label="Is the customer the Importer of Record (IoR)?"
                  value={rma.ior}
                  onChange={(val) => handleChange("ior", val)}
              />

              {rma.ior === "no" && (
                  <>
                    <Input
                        type="text"
                        label="Company name"
                        value={rma.companyname}
                        onChange={(val) => handleChange("companyname", val)}
                    />

                    <Input
                        type="text"
                        label="City "
                        value={rma.city}
                        onChange={(val) => handleChange("city", val)}
                    />
                    <Input
                        type="text"
                        label="Name"
                        value={rma.name}
                        onChange={(val) => handleChange("name", val)}
                    />
                    <Input
                        type="text"
                        label="Region "
                        value={rma.region}
                        onChange={(val) => handleChange("region", val)}
                    />

                    <Input
                        type="text"
                        label="Email"
                        value={rma.email}
                        onChange={(val) => handleChange("email", val)}
                    />
                    <Input
                        type="text"
                        label="Country "
                        value={rma.country}
                        onChange={(val) => handleChange("country", val)}
                    />
                    <Input
                        type="text"
                        label="Phone Number"
                        value={rma.phonenumber}
                        onChange={(val) => handleChange("phonenumber", val)}
                    />
                    <Input
                        type="text"
                        label="Zip Code "
                        value={rma.zip}
                        onChange={(val) => handleChange("zip", val)}
                    />
                    <Input
                        type="text"
                        label="Address Line 1 "
                        value={rma.address1}
                        onChange={(val) => handleChange("address1", val)}
                    />
                    <Input
                        type="text"
                        label="Address Line 2 "
                        value={rma.address2}
                        onChange={(val) => handleChange("address2", val)}
                    />
                  </>
              )}
            </>
          </div>
        </section>

        {/* <section className="form-section">
        <h3>SLA & OLA</h3>
        <div className="grid">
          {isAdmin && (
            <>
              <Input
                type="text"
                label="OLA"
                value={rma.ola}
                onChange={(val) => handleChange("ola", val)}
              />
              <Input
                type="text"
                label="OLA Status"
                value={rma.olaStatus}
                onChange={(val) => handleChange("olaStatus", val)}
              />
            </>
          )}
        </div>
      </section> */}

        <section className="form-section">
          <h3>Related Object</h3>
          <div className="grid">
            <></>

            {isAdmin && (
                <>
                  <button onClick={handleOpenTaskLookup}>
                    Select Related Ticket
                  </button>
                  {selectedTask && selectedTask.length > 0 && (
                      <div>
                        <p>
                          <strong>Selected Tasks:</strong>
                        </p>
                        <ul>
                          {selectedTask.map((task, index) => (
                              <li key={index}>{task.ticketId}</li>
                          ))}
                        </ul>
                      </div>
                  )}
                  <TaskGridLookup
                      isOpen={isTaskLookupOpen}
                      onClose={handleCloseTaskLookup}
                      onSelect={handleTaskSelect}
                  />{" "}
                </>
            )}
          </div>
        </section>

        <div className="submit-section">
          <Button onClick={handleSubmit}>Submit RMA</Button>
        </div>
      </div>
  );
};

export default RmaAdd;
